import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-file',
    imports: [
        FormsModule,
        FormlyModule,
        ReactiveFormsModule,
    ],
    template: ` <input type="file" 
                    [formControl]="formControl" 
                    [formlyAttributes]="field"
                    (change)="fileChanged($event)"
               /> `
})

export class ZopFileUploadComponent extends FieldType<FieldTypeConfig> {

  fileChanged(event: any){
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
       for (let i = 0; i < filesAmount; i++) {
          var reader = new FileReader();

          reader.onload = (event: any) => {
            console.log(event.target.result);
            console.log(this.formControl);
          }
          reader.readAsDataURL(event.target.files[i]);
       }
    }
  }
}